module.exports = __webpack_public_path__ + "static/visa_innovation_program_europe-1f46b3d3977c167af1cfde669a1aa0d6.png";